var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "siteUseBox" }, [
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "div",
          {
            staticClass: "columnText2",
            staticStyle: { "margin-right": "0.1rem" },
          },
          [_vm._v(" 会场预定号 ")]
        ),
        _c("el-input", {
          staticClass: "columnText3",
          staticStyle: { flex: "1" },
          attrs: {
            disabled: _vm.disabled,
            size: "small",
            "placeholder-class": "placeholder",
            placeholder: "请输入会场预定号（如有）",
            type: "text",
          },
          model: {
            value: _vm.datas.useNumber,
            callback: function ($$v) {
              _vm.$set(_vm.datas, "useNumber", $$v)
            },
            expression: "datas.useNumber",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "column" }, [
      _c(
        "div",
        {
          staticClass: "columnText4",
          staticStyle: { "margin-right": "0.1rem" },
        },
        [_vm._v(" 如何使用会场 ")]
      ),
      _c("div", { staticStyle: { flex: "1" } }, [
        _c(
          "div",
          { staticClass: "columnText3", staticStyle: { "font-size": "22rpx" } },
          [_vm._v(_vm._s(_vm.datas.useMethod ? _vm.datas.useMethod : "未填写"))]
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "div",
          {
            staticClass: "columnText4",
            staticStyle: { "margin-right": "0.1rem" },
          },
          [_vm._v(" 使用说明文字描述 ")]
        ),
        _c("el-input", {
          staticClass: "columnText3",
          staticStyle: { flex: "1" },
          attrs: {
            disabled: _vm.disabled,
            size: "small",
            "placeholder-class": "placeholder",
            placeholder: "请输入使用说明文字描述",
            type: "text",
          },
          model: {
            value: _vm.datas.useExplain,
            callback: function ($$v) {
              _vm.$set(_vm.datas, "useExplain", $$v)
            },
            expression: "datas.useExplain",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }